import messages from "@smartmixin/i18n/dist/translations/pt.json";

export default messages;
